import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape, ugcQuotationShape } from '@bibliocommons/bc-prop-types';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';
import TextUGCEditor from '../TextUGCEditor';

const CHARACTER_LIMIT = 1000;

export class QuotationUGCEditor extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleTextChange', 'handleSave', 'handleReset');

    this.textAreaRef = null;

    this.state = {
      quotation: '',
      quotationId: null
    };
  }

  componentWillMount() {
    const { existingQuotation } = this.props;
    if (existingQuotation && existingQuotation.get('quotation')) {
      this.setState({
        quotationId: existingQuotation.get('id'),
        quotation: existingQuotation.get('quotation')
      });
    }
  }

  handleTextChange(value) {
    this.setState({ quotation: value });
  }

  handleSave(callback) {
    const { quotation, quotationId } = this.state;
    const { bib, quotationsActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const postSuccess = callback;

    if (quotationId) {
      quotationsActions.updateQuotation({
        quotation,
        metadataId,
        quotationId,
        postSuccess
      });
    } else {
      quotationsActions.addQuotation({
        quotation,
        metadataId,
        postSuccess
      });
    }
  }

  handleReset() {
    this.setState({
      quotationId: null,
      quotation: ''
    }, () => {
      if (this.textAreaRef) {
        setFocusWithinElement(this.textAreaRef);
      }
    });
  }

  render() {
    const { quotation, quotationId } = this.state;
    const { bib, quotationsTransactions, shelfItem, shelfActions, shelfTransactions, handleClose, intl } = this.props;

    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const renderHeader = () => (<h2>{quotationId ? <FormattedMessage id="my_quotation" /> : <FormattedMessage id="add_quotation" />}</h2>);
    const isSavingQuotation = quotationId ? quotationsTransactions.getIn([metadataId, quotationId, 'isUpdating'], false) : quotationsTransactions.getIn([metadataId, 'isAdding'], false);
    const placeholder = intl.formatMessage({ id: 'quotation_placeholder' });
    const textAreaLabel = <FormattedMessage id="quotation" />;

    return (
      <TextUGCEditor
        bib={bib}
        characterLimit={CHARACTER_LIMIT}
        className="cp-quotation-ugc-editor"
        errorKey="quotation"
        renderHeader={renderHeader}
        handleClose={handleClose}
        handleReset={this.handleReset}
        handleSave={this.handleSave}
        handleTextChange={this.handleTextChange}
        placeholder={placeholder}
        isSaving={isSavingQuotation}
        showPrivacyAlert
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
        textAreaLabel={textAreaLabel}
        textAreaRef={(el) => { this.textAreaRef = el; }}
        text={quotation} />
    );
  }
}

QuotationUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingQuotation: ugcQuotationShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default injectIntl(QuotationUGCEditor);



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/QuotationUGCEditor/QuotationUGCEditor.jsx